module.exports = __webpack_public_path__ + "images/8f448b81.png";